'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var createPalette = {};

exports.__exports = createPalette;
